module.exports = __webpack_public_path__ + "img/double_bubble_layout_1.fb27b4f6.png";